import * as THREE from 'three';

// Inverted-hull ink outline: a back-face copy of each mesh pushed out along its normals in screen space.
// One uniform set per (cached, shared) scene; each canvas writes its own size right before it renders.
export const outlineUniforms = (scene) => {
  scene.userData.__outlineU = scene.userData.__outlineU
    || { outlineWidth: { value: 2 }, outlineRes: { value: new THREE.Vector2(800, 600) } };
  return scene.userData.__outlineU;
};

function makeMaterial(uniforms) {
  const mat = new THREE.MeshBasicMaterial({ side: THREE.BackSide, toneMapped: false });
  mat.onBeforeCompile = (shader) => {
    Object.assign(shader.uniforms, uniforms);
    shader.vertexShader = shader.vertexShader
      .replace('#include <common>', '#include <common>\nuniform float outlineWidth;\nuniform vec2 outlineRes;')
      .replace('#include <project_vertex>', `#include <project_vertex>
        #ifdef USE_SKINNING
          vec3 oN = objectNormal;
        #else
          vec3 oN = normal;
        #endif
        vec2 cn = (projectionMatrix * vec4(normalize(normalMatrix * oN), 0.0)).xy;
        if (length(cn) > 1e-5) gl_Position.xy += normalize(cn) * outlineWidth * 2.0 / outlineRes * gl_Position.w;`);
  };
  return mat;
}

export function applyOutline(scene, { on, color }) {
  const uniforms = outlineUniforms(scene);
  const meshes = [];
  scene.traverse((o) => { if (o.isMesh && !o.userData.__isOutline) meshes.push(o); });
  meshes.forEach((o) => {
    let line = o.userData.__outline;
    if (!line && on) {
      const mat = makeMaterial(uniforms);
      line = o.isSkinnedMesh ? new THREE.SkinnedMesh(o.geometry, mat) : new THREE.Mesh(o.geometry, mat);
      if (o.isSkinnedMesh) line.bind(o.skeleton, o.bindMatrix);
      if (o.morphTargetInfluences) {
        line.morphTargetInfluences = o.morphTargetInfluences;
        line.morphTargetDictionary = o.morphTargetDictionary;
      }
      line.userData.__isOutline = true;
      line.userData.__origVisible = true;
      line.frustumCulled = false;
      // Keep the hull out of the camera auto-fit (an empty box adds nothing).
      if (line.isSkinnedMesh) { line.boundingBox = new THREE.Box3(); line.computeBoundingBox = () => {}; }
      line.raycast = () => {};
      o.add(line);
      o.userData.__outline = line;
    }
    if (!line) return;
    line.material.color.set(color);
    line.material.visible = on;
  });
}
